import { render } from "./ButtonCta.vue?vue&type=template&id=c606cb14"
import script from "./ButtonCta.vue?vue&type=script&lang=js"
export * from "./ButtonCta.vue?vue&type=script&lang=js"

import "./ButtonCta.vue?vue&type=style&index=0&id=c606cb14&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__